import { IconProps } from "@/components/Icons/index";

export const CoinLogo: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/coin.png" alt="iocoin" {...props} />;
};
